import React from "react";
import CustomButton from "../../components/form/CustomButton";
const StopsList = ({ items, deleteItem, setNewStop }) => {
    return (
        <>
            <div className="flex justify-end gap-3">
                <CustomButton
                    type="button"
                    onClick={() => setNewStop(true)}
                    className="
              inline-flex items-center gap-2
              px-4 py-2.5
              rounded-xl
              shadow-md hover:shadow-lg
              transition-all
            "
                >
                    Add Stop
                </CustomButton>
            </div>
            <div className="overflow-x-auto">

                <table className="min-w-full text-sm text-left">
                    <thead className="bg-cs-bg-alt border-b border-cs-border">
                        <tr>
                            <th className="px-4 py-2 text-[11px] font-semibold text-cs-muted uppercase tracking-wide">
                                #
                            </th>
                            <th className="px-4 py-2 text-[11px] font-semibold text-cs-muted uppercase tracking-wide">
                                Address
                            </th>
                            <th className="px-4 py-2 text-[11px] font-semibold text-cs-muted uppercase tracking-wide">
                                Status
                            </th>
                            <th className="px-4 py-2 text-[11px] font-semibold text-cs-muted uppercase tracking-wide text-right">
                                Mile
                            </th>
                            <th className="px-4 py-2 text-[11px] font-semibold text-cs-muted uppercase tracking-wide">
                                Load date / time
                            </th>
                            <th className="px-4 py-2 text-[11px] font-semibold text-cs-muted uppercase tracking-wide">
                                Delivery date / time
                            </th>
                            <th className="px-4 py-2 text-[11px] font-semibold text-cs-muted uppercase tracking-wide text-right">
                                Actions
                            </th>
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-cs-border">
                        {items.length === 0 && (
                            <tr>
                                <td
                                    colSpan={7}
                                    className="px-4 py-4 text-xs text-cs-muted text-center"
                                >
                                    No stops added yet.
                                </td>
                            </tr>
                        )}

                        {items.map((item, i) => (
                            <tr
                                key={i}
                                className="hover:bg-cs-surface-alt transition-colors"
                            >
                                <td className="px-4 py-2 text-xs text-cs-muted">
                                    {item.order}
                                </td>
                                <td className="px-4 py-2 text-sm text-cs-dark">
                                    {item.name}
                                </td>
                                <td className="px-4 py-2 text-xs text-cs-muted">
                                    {item.status?.name}
                                </td>
                                <td className="px-4 py-2 text-sm text-right text-cs-dark">
                                    {item.mile}
                                </td>
                                <td className="px-4 py-2 text-xs text-cs-muted">
                                    {item.date} {item.load_time}
                                </td>
                                <td className="px-4 py-2 text-xs text-cs-muted">
                                    {item.delivery_date} {item.delivery_time}
                                </td>
                                <td className="px-4 py-2 text-right">
                                    <button
                                        type="button"
                                        onClick={() => deleteItem("stops", item)}
                                        className="
                inline-flex items-center justify-center
                h-8 w-8
                rounded-lg
                border border-cs-border
                bg-cs-bg
                hover:bg-cs-bg-alt
                transition-colors
              "
                                    >
                                        <i className="fas fa-trash text-cs-danger text-xs" />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </>
    )
}

export default StopsList